export default __webpack_public_path__ + "static/media/LOGO.9c72fb43.png";